var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-radio-group',{attrs:{"hide-details":"","row":""},model:{value:(_vm.selectedTextbook),callback:function ($$v) {_vm.selectedTextbook=$$v},expression:"selectedTextbook"}},_vm._l((_vm.textbooks),function(textbook,index){return _c('v-radio',{key:index,attrs:{"label":textbook.text,"value":textbook.value,"color":"secondary"}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }